module.exports = __webpack_public_path__ + "img/u1208.6ab7a022.svg";